<template>
    <div class="div">
        <datetime
                :input-class=" isFilled ? 'bold button is-small date-select ' : 'button is-small date-select'"
                v-model="carData.query.rec_fee_refunded"
                :format="{ month: 'numeric', day: 'numeric'}"
                type="date"
                value-zone="local"
                zone="local"
                @close="selectDate"
                :input-id="carData.id.toString()"
                placeholder="---"
        ></datetime>
    </div>
</template>

<script>
    import apiCars from './../../../api/apiCars'
    import { Datetime } from 'vue-datetime'
    import 'vue-datetime/dist/vue-datetime.css'
    export default {
        props:['car'],
        components: {
            Datetime
        },
        data () {
            return {
                isActive: false,
                carData:{
                    id: this.car.id,
                    query: {
                        rec_fee_refunded: this.car.rec_fee_refunded,
                    }
                }
            }
        },
        methods: {
            selectDate() {
                apiCars
                    .updateCarRequest(this.carData)
                    .then((response) => {
                        this.car.rec_fee_refunded = this.carData.query.rec_fee_refunded
                    })
                    .catch(error => console.log(error))
            },

        },
        computed: {
            isFilled() {
                if (this.carData.query.rec_fee_refunded){
                    return  true;
                }
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/RecFee/RecFeeRefundedColumn.vue